import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/quality-assurance/qms-remediation-support")({
  beforeLoad: () => { throw redirect({ to: "/zh-cn/services/quality-assurance/qms-development-optimization", statusCode: 301 }); },
});
